/* istanbul ignore file */

export class PointCategory {
    id: string;
    name: string;
    fillColor: number;
    matIcon: string;
}
